(function () {
  'use strict';

  angular
    .module('navigation')
    .config(config);

  function config($translateProvider) {

      var data = {
          messages: {
              "createBtn": "Kreiraj novu poruku",
              "header": "Poruke",
              "receivedTab": "Primljene",
              "sentTab": "Poslate",
              "unreadLabel": "Nepročitane poruke",
              "readLabel": "Pročitane poruke",
              "replyBtn": "Odgovori",
              "printBtn": "Štampaj",
              "deleteBtn": "Obriši",
              "noData": "Za odabrani period nema poruka",
              "loadMore":"Učitaj više",
              "downloadAttachment": "Preuzmi prilog"
          },
          "newMessage": {
              "titleLabel": "Nova poruka",
              "titleReplyLabel": "Odgovori na poruku",
              "subjectLabel": "Naslov",
              "subjectPlaceholder": "Unesite naslov poruke ovde",
              "bodyLabel": "Sadržaj",
              "backBtn": "Nazad",
              "sendBtn": "Pošalji",
              "successLabel1": "Poruka poslana",
              "successLabel2": "Poruka ",
              "successLabel3": " je uspješno poslana!",
              "newLabel": "Kreiraj novu poruku",
              "goToMsgsLabel": "Idi na poruke"
              
          },
          "complaint": {
              "createBtn": "Kreiraj novi prigovor",
              "titleLabel": "Podnesi prigovor",
              "subjectLabel": "Naslov",
              "subjectPlaceholder": "Unesite naslov prigovora ovde",
              "bodyLabel": "Opis prigovora",
              "noData": "Za odabrani period nema prigovora",
              "header": "Prigovori",
              "backBtn": "Nazad",
              "sendBtn": "Pošalji",
              "successLabel1": "Prigovor poslan",
              "successLabel2": "Prigovor ",
              "successLabel3": " je uspješno poslan!",
              "newLabel": "Kreiraj novi prigovor",
              "goToMsgsLabel": "Idi na prigovore",
              "receivedTab": "Odgovori na prigovore",
              "sentTab": "Prigovori",
          }
      };

    $translateProvider
      .translations('sr', data);

  }
}());

